// Asset URLs from customer assets
export const ASSETS = {
  videos: {
    hero: 'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/8ztdez0y_Movie0038.mp4',
    polishedConcrete: 'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/35n6zz2b_20210927_125408.mp4',
    grindAndSeal: 'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/if82eaz1_20240806_115230.mp4',
    honedConcrete: 'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/gaie6d3z_20220129_145002.mp4',
    concreteGrinding: 'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/m71jydqb_VID-20250917-WA0054.mp4#t=2'
  },
  images: {
    aggregateLevels: 'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/sz3n8a5f_WhatsApp-Image-2024-12-29-at-21.35.50.jpeg',
    doltoneHouse: [
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/dyyrz6id_WhatsApp-Image-2025-01-08-at-18.19.351-1536x864.jpeg',
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/20iw6ie0_La-Maison-2-scaled.jpg',
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/qk68fgh9_La-Maison-3-scaled.jpg',
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/13r63r32_AZ_4739-1.jpg',
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/i5p7zi92_HB_IMG-46-1-scaled.jpg',
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/f4piw723_La-Maison-4-scaled.jpg',
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/2dm70nbe_Doltone-House-Sylvania-Waters-La-Maison-Banquet-89-scaled.jpg',
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/3q2ap24d_DSC00163-scaled.jpg',
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/6g336eoo_Doltone-House-Sylvania-Waters-La-Maison-Banquet-92-scaled.jpg',
      'https://customer-assets.emergentagent.com/job_concrete-vision/artifacts/5z1q1y7w_Doltone-House-Sylvania-Waters-Corporate-Open-Day-65.jpg'
    ]
  }
};

export const SERVICES = [
  {
    name: 'Polished Concrete',
    slug: 'polished-concrete',
    video: ASSETS.videos.polishedConcrete,
    description: 'High-gloss, durable, reflective finish that transforms ordinary concrete into a stunning, mirror-like surface.',
    longDescription: 'Polished concrete flooring is the ultimate choice for commercial and residential spaces seeking a sophisticated, low-maintenance solution. Through diamond grinding and polishing, we expose the aggregate beneath and create a lustrous finish that reflects light beautifully. This eco-friendly option is extremely durable, resists stains, and improves with age.'
  },
  {
    name: 'Grind and Seal',
    slug: 'grind-and-seal',
    video: ASSETS.videos.grindAndSeal,
    description: 'Satin-smooth sealed concrete finish. Quick installation and cost-effective solution for various applications.',
    longDescription: 'Our grind and seal service provides a durable, economical alternative to full polishing. We grind the surface to your desired level of aggregate exposure, then apply a high-quality sealer for protection. This method offers excellent resistance to chemicals, abrasion, and moisture while achieving a smooth satin finish.'
  },
  {
    name: 'Honed Concrete',
    slug: 'honed-concrete',
    video: ASSETS.videos.honedConcrete,
    description: 'Matte finish concrete for outdoor areas. Slip-resistant surface perfect for pools, driveways, and patios.',
    longDescription: 'Honed concrete delivers a completely matte finish ideal for outdoor applications. This slip-resistant surface is perfect for footpaths, porches, pool surrounds, flat or low gradient driveways, and outdoor sitting and relaxing areas. We use penetrating sealers that protect the concrete while maintaining its natural breathability. This finish is UV stable, weather-resistant, and provides excellent slip resistance ratings for safety in wet conditions.'
  },
  {
    name: 'Concrete Grinding Floor Prep',
    slug: 'concrete-grinding-floor-prep',
    video: ASSETS.videos.concreteGrinding,
    description: 'Professional surface preparation for new finishes, coatings, and overlays. Essential for flawless results.',
    longDescription: 'Proper surface preparation is crucial for any flooring project. Our concrete grinding service removes existing coatings, levels uneven surfaces, and creates the perfect profile for new finishes. Whether you\'re installing epoxy, overlays, or tiles, we ensure a clean, properly textured surface for maximum adhesion and longevity.'
  }
];

export const COMPANY_INFO = {
  name: 'Polished Concrete Sydney',
  tagline: 'Perfecting Concrete Surfaces Across Sydney',
  email: 'sydneyconcretepolishers@gmail.com',
  phone: '+61 478 076 070',
  whatsapp: '+61478076070',
  address: 'Sydney, New South Wales',
  youtube: 'http://www.youtube.com/@sydneyconcretepolishers',
  instagram: 'https://www.instagram.com/sydneyconcretepolishers',
  description: 'Premier concrete polishing specialists serving Sydney\'s commercial and residential sectors. With years of expertise and cutting-edge equipment, we transform ordinary concrete into extraordinary surfaces that combine beauty, durability, and sustainability.'
};
